import * as React from 'react';
import AmCharts from "@amcharts/amcharts3-react";
import * as moment from 'moment';
import { _ } from "@src/services/i18n";
import { classNames, css, mixin, vars, defaultProps, formatters } from '@src/services/theme';
import { Proto, Props, State } from '@src/components/Proto';
import { Box } from '@src/components';

// typing

// style
const style = css`
    background: ${vars.colors.greyLight};
    border: 1px solid ${vars.colors.grey};
    
    h4 {
        font-size: 24px;
        text-align: center;
    }
`;

// component
export class Charge extends Proto<Props, State> {
    parseGraphData( ) {
        const { data } = this.state;
        return data.data.socdata.map( v => {
            const {date, soc, lineColor} = v;
            return {
                date: moment(date).toDate(),
                val: soc,
                lineColor
            }
        });
    }

	// render
	render() {
        const loading = this.loading();
        if (loading) return loading;
        const { data } = this.state;
        const { last_state } = data;

        const config = {
            ...defaultProps.graphArea(),
            "dataProvider": this.parseGraphData()
        };
        
		return (
            <div className={style}>
                <h4>{_(`charge_title`, 'BatteryCycle')}</h4>
                <AmCharts.React style={{ width: "100%", height: "400px" }} options={config} />
            </div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/BatteryCycle/Charge.tsx